module.exports = __webpack_public_path__ + "img/02 Delmax.4f35a80f.png";